import { Component, Input, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/profile/profile.service';

interface MeterIndicator {
  value: string;
  active: boolean;
}

const ALERT_CIRCLE = 'alert-circle-red';
const CHECK_CIRCLE = 'check-circle';

@Component({
    selector: 'app-completion-meter',
    templateUrl: './completion-meter.component.html',
    styleUrls: ['./completion-meter.component.scss'],
    standalone: false
})
export class CompletionMeterComponent implements OnInit {
  @Input() meterLength: number;
  @Input() completionLength: number;
  completionMeter: MeterIndicator[];
  completionIcon: string;

  constructor(
    private readonly profileService: ProfileService
  ) {
    this.completionMeter = [
      { value: 'box1', active: false },
      { value: 'box2', active: false },
      { value: 'box3', active: false },
      { value: 'box4', active: false },
      { value: 'box5', active: false },
      { value: 'box6', active: false }
    ];
  }

  ngOnInit(): void {}
  ngOnChanges(): void {
    this.completionMeter.forEach((meter: MeterIndicator) => (meter.active = false));
    this.completionIcon = this.meterLength <= this.completionLength && !this.profileService.isProfileInfoNeeded() ? CHECK_CIRCLE : ALERT_CIRCLE;
    if (this.completionLength > 0) {
      let completionCount = this.completionLength;
      this.completionMeter.forEach((element: MeterIndicator) => {
        if (completionCount > 0) {
          element.active = true;
        } else {
          return;
        }
        completionCount = completionCount - 1;
      });
    }
  }
}
